module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./ProductListView.js"));
	}, "ProductListView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ProductListView!./src/pages/Shop/Product/ProductList/ProductListView.js
// module id = 1348
// module chunks = 418